import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {AccountService} from "./account.service";
import {Receipt} from "../models/receipt";
import {OrdersFilter} from "../models/ordersFilter";
import {Orders} from "../models/orders";
import {ReceiptList} from "../models/receiptList";

@Injectable({ providedIn: 'root' })
export class ReceiptService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getByOrderUuid(uuid: string) {
        return this.http.get<Receipt>(`${environment.apiEndpoint}/v1/receipts/${uuid}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    repeatPrinting(uuid: string) {
        return this.http.post<Receipt>(`${environment.apiEndpoint}/v1/receipts/${uuid}/repeat-printing`, {},{
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllErrorReceipts(offset: number, limit: number) {
        return this.http.get<ReceiptList>(`${environment.apiEndpoint}/v1/receipts?offset=`+offset+`&limit=`+limit + '&filters[errorCode]=true', {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
